import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  blockContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    minHeight: '400px',
  },
  printContainer: {
    position: 'absolute',
    zIndex: -1,
    opacity: 0,
  },
  printTable: {
    padding: '0 20px 20px 20px',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '5px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.3)',
  },
  filterBlock: {
    height: '50px',
    gap: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  filterWrapper: {
    padding: '0px 10px 0px 20px',
    maxHeight: '300px',
    overflowY: 'auto',
    width: '100%',
  },
  filterItemWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px 10px 5px 5px',
  },
  filterIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  buttonDiv: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '5px 10px',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
  },
});
